import React from "react";
import Article from "./Article";
import Icon from "./Icon";
import './Card.css'

function Card (props) {
    return (
        <div className={"Card"}>
            <Icon name={props.name} />
            <h3>{props.name}</h3>
            <Article name={props.name}/>
        </div>
    );
}

export default Card;